import { render, staticRenderFns } from "./text-row-price.vue?vue&type=template&id=0cddacb2&scoped=true&"
import script from "./text-row-price.vue?vue&type=script&lang=js&"
export * from "./text-row-price.vue?vue&type=script&lang=js&"
import style0 from "./text-row-price.vue?vue&type=style&index=0&id=0cddacb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cddacb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cddacb2')) {
      api.createRecord('0cddacb2', component.options)
    } else {
      api.reload('0cddacb2', component.options)
    }
    module.hot.accept("./text-row-price.vue?vue&type=template&id=0cddacb2&scoped=true&", function () {
      api.rerender('0cddacb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/text-row-price.vue"
export default component.exports